import React from 'react';
import { LEADERBOARD_COLUMNS } from '../../metadata/fields.js';

function LeaderboardTableHeaderRow({ sortColumn, setSortColumn, sortAscending, setSortAscending }) {
    const handleSortSelection = (column) => {
        if(sortColumn !== column) {
            setSortColumn(column);
            setSortAscending(false);
        } else {
            setSortAscending(!sortAscending);
        }
    }

    const sortArrow = (column) => {
        if(column === sortColumn){
            return sortAscending ? '↑' : '↓';
        }
    }

    const columnHeaders = Object.keys(LEADERBOARD_COLUMNS).map((column, index) => {
        return (
            <>
            { LEADERBOARD_COLUMNS[column].filterable ? 
                <th key={index} className={column === sortColumn ? 'highlight' : ''} onClick={() => handleSortSelection(column)}>{LEADERBOARD_COLUMNS[column].label}<span className="clanleaderboard_table_arrow " >&nbsp;{sortArrow(column)}</span></th> : null
            }
            </>
        ) 
    });

    const clanNameHeader = <th>{LEADERBOARD_COLUMNS['clan_db_id'].label}</th>
    const rankHeader = <th>Rank</th>


    return (
        <tr>
            { rankHeader }
            { clanNameHeader }
            { columnHeaders }
        </tr>
    )
}

export default LeaderboardTableHeaderRow;
